import React, { useState } from 'react'
import "./Style/Style.css";
import { Link } from "react-router-dom";
import {useNavigate} from 'react-router-dom'
import { ToastContainer, toast } from "react-toastify";

const Navbar = ({setProgress}) => {
    let navigate = useNavigate();
    const [isActive, setIsActive] = useState(false);
    const show = () =>{
       setIsActive(true)
    }
    const hide = (e)=>{
        e.preventDefault();
        setIsActive(false)
    }
    const handlelogout = ()=>{
      setProgress(20)
      setProgress(40)
      setProgress(60)
      localStorage.removeItem('userdatatoken')
      setProgress(80)
      setProgress(100)
      navigate("/login");
      toast.success("Logout Succesfully!", {
        position: "top-center",
      });
    }
  return (
    <div>
      <section id="header">
           <Link to="/" className="logo"><span>MARG</span>DARSHAK</Link>
           {/*  <Link to="/" className="logo"> <img src={logo} alt="" /> */}
            <div>
                <ul id="navbar" className={`${isActive ? "active" : ""}`}>
                   <li><Link to="/">Home</Link></li>
                   <li><Link to="/about"> About</Link></li>
                   <li><Link to="/services">Services</Link></li>
                   <li><Link to="/contact">Appointment</Link></li>
                   <li><Link to="/blog">Blog</Link></li>
                   {
                    !localStorage.getItem('userdatatoken') ? <li><Link className='loginpage' to="/login">Login</Link></li> :
                    <button onClick={handlelogout} className='btnl'>logout</button>
                   }
                   
                  <a href="/" id="close" onClick={hide}><i className="fas fa-times"></i></a>
                </ul>
            </div>
            <div id="mobile">
               <i id="bar" onClick={show} className="fas fa-outdent"></i>
            </div>
        </section>
        <ToastContainer />
    </div>
  )
}

export default Navbar
